import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function FileFormatter({ info }) {
  const { value } = getInfo(info)

  if ([undefined, null].includes(value)) {
    return '--'
  }

  return value
}
